export default {
  SUPERSET_DOMAIN: 'https://demo-superset.raftds.com',
  URL_SUPERSET_LOGIN: '/proxy/Superset/login',
};
